// Global configuration and constants
const BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://www.rimtic.com'
  : 'https://rimtic.com';

const STORAGE_URL = `${BASE_URL}/storage/`;
const IMAGES_URL = `${BASE_URL}/images/`;
const CVTHEQUE_URL = `${BASE_URL}/cvtheque-f`;

export {
  BASE_URL,
  STORAGE_URL,
  IMAGES_URL,
  CVTHEQUE_URL,
};
